export class SavedReport {
  id: number = -1;
  name: string = '';
  mode: string = '';
  entity: string = '';
  spec: string = '';
  createdAt: string = '';
  updatedAt: string = '';
}
